export default {
  carLicenseDetail: '车证详情',
  revise: '修改',
  back: '返回',
  state: '状态',
  CompanyNameOfBuilder: '公司名',
  eMail: '邮箱',
  number: '数量',
  BoothNumber: '展位号',
  Addressee: '收件人',
  ContactInformation: '联系方式',
  postCode: '邮编',
  address: '地址',
  carLicenseApply: '车证申请',
  add: '新增申请',
  carLicenseApplyList: '车证申请列表',
  ExhibitionName: '展会名称',
  carLicenseType: '车证类型',
  carLicenseNumber: '车证数量',
  ViewDetails: '查看详情',
  local: '本地货车证',
  ForeignPort: '外埠货车证',
  submit: '提交',
  ContactInfo: '联系信息',
  name: '联系人姓名',
  phoneNumber: '联系方式',
  plateNumber: '车牌号',
  remark: '备注',
  operation: '操作',
  next: '下一步',
  addresss: '邮寄地址',
  HistoryFillInRecords: '历史填写记录',
  check: '可直接勾选',
  '本页面无法修改车证申请，如有所需点击': '本页面无法修改车证申请，如有所需点击',
  '车证申请': '车证申请',
  '进行修改': '进行修改',
  '上一步': '上一步',
  '下一步': '下一步',
  '请输入公司名称': '请输入公司名称',
  '请输入邮箱': '请输入邮箱',
  '请输入申请车证数量': '请输入申请车证数量',
  '请输入车证信息回车查询': '请输入车证信息回车查询',
  '返回': '返回',
  '请输入展位号回车查询': '请输入展位号，回车查询',
  'Excel导入': 'Excel导入',
  '请输入联系人姓名': '请输入联系人姓名',
  '请输入联系方式': '请输入联系方式',
  '请输入正确的联系方式': '请输入正确的联系方式',
  '请输入车牌号': '请输入车牌号',
  '如有特殊情况请说明': '如有特殊情况请说明',
  '新增人员': '新增人员',
  '请输入收件人姓名': '请输入收件人姓名',
  '请输入联系电话': '请输入联系电话',
  '请输入邮编': '请输入邮编',
  '请输入邮寄地址': '请输入邮寄地址',
  '下载工作人员资料模板': '下载工作人员资料模板',
  '选择上传文件': '选择上传文件',
  '上传': '上传',
  '姓名': '姓名',
  '无': '无',
  '请输入有效的邮箱': '请输入有效的邮箱',
  '请输入有效的手机号': '请输入有效的手机号',
  '创建成功': '创建成功',
  '添加车证成功': '添加车证成功',
  '提示': '提示',
  '是否确认提交': '是否确认提交',
  '确定': '确定',
  '取消': '取消',
  '本地': '本地',
  '外埠': '外埠',
  '男': '男',
  '女': '女',

  '车证归属地': '车证归属地',
  '本地车证': '本地车证',
  '外埠车证': '外埠车证',
  '展会举办地的车证即为本地车证': '展会举办地的车证即为本地车证',
  '非展会举办地的车证即为外埠车证': '非展会举办地的车证即为外埠车证',
  '通行许可证获取方式': '通行许可证获取方式',
  '身份证正面照片': '身份证正面照片',
  '驾驶证照片': '驾驶证正副本',
  '行驶证照片': '行驶证正副本',
  '车牌号码': '车牌号码',
  '车牌类型': '车牌类型',
  '车辆类型': '车辆类型',
  '请输入正确的车牌号': '请输入正确的车牌号',
  '货车证': '货车证',
  '小车证': '小车证',
  '暂未开放该项证件的申请': '暂未开放该项证件的申请',
  '领取方式': '领取方式',
  '现场领取': '现场领取',
  '请在下方表格中添加展位号': '请在下方表格中添加展位号',

}



// WEBPACK FOOTER //
// ./src/i18n/zh-cn/carLicenseApply.js